import React, {Fragment} from "react";
import Flickity from 'react-flickity-component';
const axios = require('axios');

import {CART_UPDATED, OPEN_CART} from "../util/events";
import CloseIcon from "../icons/CloseIcon";
import CartLineItem from "./CartLineItem";
import dispatchEvent from "../util/dispatchEvent";

class Cart extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            loaded: false,
            items: null,
            notes: '',
            tax: null,
            sub_total: null,
            total: null,
            total_items: null,
            related_items: null,
            checkout_link: '',
            cart_message: null,
            shipping_cost: null,
            shipping_title: null,
            dg_surcharge: null,
            discounts: null,
            discounts_title: null,
            discount_code: '',
            discount_code_original: null,
            discount_message: null,
            is_edit: false,
        }

        this.openCart = this.openCart.bind(this);
        this.closeCart = this.closeCart.bind(this);
        this.updateCartData = this.updateCartData.bind(this);
        this.updateNotes = this.updateNotes.bind(this);
        this.updateDiscountCode = this.updateDiscountCode.bind(this);
        this.applyDiscountCode = this.applyDiscountCode.bind(this);
        this.applyDiscountCodeEnter = this.applyDiscountCodeEnter.bind(this);
    }

    componentDidMount()
    {
        this.bindEventListeners();
    }

    openCart()
    {
        this.setState({
            opened: true
        });
    }

    updateCartData(e)
    {
        const data = e.data;

        this.setState({
            items: null,
            notes: '',
            tax: null,
            sub_total: null,
            total: null,
            total_items: null,
            related_items: null,
            checkout_link: '',
            cart_message: null,
            shipping_cost: null,
            shipping_title: null,
            dg_surcharge: null,
            discounts: null,
            discounts_title: null,
            discount_code: '',
            discount_code_original: null,
            discount_message: null,
            is_edit: false,
        }, () => {

            this.setState({
                items: data.items,
                notes: data.notes,
                sub_total: data.sub_total,
                tax: data.tax,
                total: data.total,
                total_items: data.total_items,
                related_items: data.related_items,
                checkout_link: data.checkout_link,
                cart_message: data.cart_message,
                shipping_cost: data.shipping_cost,
                shipping_title: data.shipping_title,
                dg_surcharge: data.dg_surcharge,
                discounts: data.discounts,
                discounts_title: data.discounts_title,
                discount_code: data.discount_code,
                discount_code_original: data.discount_code,
                loaded: true,
                discount_message: null,
                is_edit: data.is_edit
            });

        });


    }

    closeCart()
    {
        this.setState({
            opened: false
        });
    }

    updateNotes(message)
    {
        this.setState({
            notes: message
        });
        axios.post('cart-api/notes', {
            notes: message
        });
    }

    applyDiscountCodeEnter(e)
    {
        if (e.keyCode === 13) {
            this.applyDiscountCode();
        }
    }

    applyDiscountCode()
    {
        axios.post('cart-api/apply-discount', {
            code: this.state.discount_code
        }).then((response) => {
            dispatchEvent(CART_UPDATED, response.data);

            if (response.data.message) {
                this.setState({
                    discount_message : response.data.message
                });
            } else {
                this.setState({
                    discount_message : null
                });
            }
        });;
    }

    updateDiscountCode(e)
    {
        this.setState({
            discount_code: e.target.value
        });
    }

    bindEventListeners()
    {
        const body = document.querySelector('body');
        this.bindOpenCloseListener(body);
        this.bindUpdateCartContents(body);
    }

    bindOpenCloseListener(body)
    {
        body.addEventListener(OPEN_CART, this.openCart);
    }

    bindUpdateCartContents(body)
    {
        body.addEventListener(CART_UPDATED, this.updateCartData);
    }

    render() {
        let sidebarClass = 'cart-sidebar';
        if (this.state.opened) {
            sidebarClass += ' active';
        }
        if (this.props.fixed) {
            sidebarClass += ' cart-sidebar--fixed';
        }

        return <div className={sidebarClass}>
            <div className="cart-drawer">
                <div className="cart-sidebar__inner">
                    <div className="cart-sidebar__header">
                        <h3>Shopping Cart</h3>
                        {!this.props.fixed && <a className="cart-sidebar__close" onClick={this.closeCart}>
                            <CloseIcon/>
                        </a>}
                    </div>


                    {!this.state.loaded && <Fragment>
                        <div className="cart-sidebar__message">
                            <p>Loading</p>
                        </div>
                    </Fragment>}


                    {(!this.state.total_items && this.state.loaded) && <Fragment>
                        <div className="cart-sidebar__message">
                            <p>Your cart is empty.</p>
                        </div>
                    </Fragment>}

                    {!!this.state.cart_message && <div className="cart-sidebar__message"
                                                       dangerouslySetInnerHTML={{__html: this.state.cart_message}}>
                    </div>}

                    {!!this.state.total_items && <Fragment>


                        <div className="cart-sidebar__lines">
                            {this.state.items.map((item) => {
                                return <CartLineItem
                                    key={'item__' + item.id}
                                    item={item}
                                    isEdit={this.state.is_edit}
                                    cartCheckout={this.props.cartCheckout} />
                            })}
                        </div>

                        {!this.props.cartCheckout && <div className={'cart-sidebar__upsell'}>
                            <h3>People who bought these items also bought</h3>
                            <div className="cart-sidebar__upsell-slider">
                                <Flickity options={{cellAlign: 'left', pageDots: false, contain: true}}>
                                    {this.state.related_items.map((product) => {
                                        return <div className="cart-sidebar__product-slide" key={`pus__${product.id}`}>
                                            <a href={product.link} className="cart-sidebar__product-slide__inner">
                                                <div className="cart-sidebar__product-slide__image">
                                                    {!!product.image && <img src={product.image} alt={product.title} /> }
                                                </div>
                                                <h3>{product.title}</h3>
                                                <div className="cart-sidebar__product-slide__price">
                                                    {!!product.previous_price && <span className="cart-sidebar__product-slide__crossed">{product.previous_price}</span>}
                                                    {!!product.price_applied && <span className="cart-sidebar__product-slide__selling-price">{product.price_applied}</span>}
                                                </div>
                                            </a>
                                        </div>
                                    })}
                                </Flickity>
                            </div>
                        </div>}

                        {!this.props.cartCheckout && <div className={'cart-sidebar__instructions'}>
                            <h3>Delivery and Purchase Information</h3>
                            <div className="cart-sidebar__instructions__inner">
                                <textarea
                                    placeholder='Message'
                                    value={this.state.notes}
                                    onChange={(e) => { this.updateNotes(e.target.value) }}></textarea>
                            </div>
                        </div>}

                        {!this.props.cartCheckout && <div className={'cart-sidebar__coupon-holder'}>
                            <h3>Coupon Code</h3>
                            <div className={'cart-sidebar__coupon'}>
                                <input type={'text'} value={this.state.discount_code}
                                       onKeyUp={this.applyDiscountCodeEnter}
                                       onChange={this.updateDiscountCode}/>
                                <button onClick={this.applyDiscountCode}>Apply</button>
                            </div>
                            {!!this.state.discount_message && <p>{this.state.discount_message}</p>}
                        </div>}

                        <div className="cart-sidebar__totals">

                            {!!this.state.shipping_title && <div className="cart-sidebar__totals__row">
                                <h3>
                                    <span>Shipping ({this.state.shipping_title})</span>
                                    <span>{this.state.shipping_cost !== '$0.00' ? this.state.shipping_cost : ''}</span>
                                </h3>
                            </div>}
                            {this.state.dg_surcharge !== '$0.00' && <div className="cart-sidebar__totals__row">
                                <h3>
                                    <span>Dangerous goods surcharge</span>
                                    <span>{this.state.dg_surcharge}</span>
                                </h3>
                            </div>}
                            {!!this.state.discounts && <div className="cart-sidebar__totals__row">
                                <h3>
                                    <span>{this.state.discounts_title}</span>
                                    <span>-{this.state.discounts}</span>
                                </h3>
                            </div>}

                            <div className="cart-sidebar__totals__row">
                                <h3>
                                    <span>Total (including <Fragment>{this.state.tax}</Fragment> GST)</span>
                                    <span>{this.state.total}</span>
                                </h3>
                            </div>
                            {(!this.props.fixed  && !this.props.cartCheckout) && <div className={'cart-sidebar__actions'}>
                                <a href={this.state.checkout_link} className='btn btn--blue btn--blue--solid'>
                                    Checkout
                                </a>
                            </div>}
                        </div>
                    </Fragment>}
                </div>
            </div>
        </div>
    }

}

export default Cart;
